export const mockUser = {
  id: 'user-001',
  email: 'player@casino.com',
  username: 'LuckyPlayer88',
  fullName: 'John Smith',
  avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20avatar%20portrait%20with%20confident%20smile%2C%20modern%20style%2C%20clean%20background%2C%20high%20quality%20headshot&width=200&height=200&seq=avatar-001&orientation=squarish',
  balance: 15420.50,
  currency: 'USDT',
  vipLevel: 'Gold',
  totalWagered: 125000,
  totalWon: 98500,
  gamesPlayed: 1247,
  joinDate: '2024-01-15',
  lastLogin: '2025-01-20T14:30:00Z',
  verified: true,
  twoFactorEnabled: false
};

export const mockTransactions = [
  {
    id: 'tx-001',
    type: 'deposit',
    amount: 5000,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-20T10:15:00Z',
    txHash: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb1',
    network: 'TRC20'
  },
  {
    id: 'tx-002',
    type: 'withdrawal',
    amount: 2500,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-19T16:45:00Z',
    txHash: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    network: 'TRC20'
  },
  {
    id: 'tx-001',
    type: 'deposit',
    amount: 5000,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-20T10:15:00Z',
    txHash: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb1',
    network: 'TRC20'
  },
  {
    id: 'tx-002',
    type: 'withdrawal',
    amount: 2500,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-19T16:45:00Z',
    txHash: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    network: 'TRC20'
  },
  {
    id: 'tx-003',
    type: 'deposit',
    amount: 10000,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-18T09:20:00Z',
    txHash: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    network: 'ERC20'
  },
  {
    id: 'tx-004',
    type: 'withdrawal',
    amount: 3500,
    currency: 'USDT',
    status: 'pending',
    date: '2025-01-17T14:30:00Z',
    txHash: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    network: 'TRC20'
  },
  {
    id: 'tx-005',
    type: 'deposit',
    amount: 7500,
    currency: 'USDT',
    status: 'completed',
    date: '2025-01-16T11:00:00Z',
    txHash: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    network: 'ERC20'
  }
];

export const mockGameHistory = [
  {
    id: 'game-h-001',
    gameName: 'Sweet Bonanza',
    provider: 'Pragmatic Play',
    betAmount: 50,
    winAmount: 125,
    profit: 75,
    date: '2025-01-20T14:25:00Z',
    result: 'win'
  },
  {
    id: 'game-h-002',
    gameName: 'Gates of Olympus',
    provider: 'Pragmatic Play',
    betAmount: 100,
    winAmount: 0,
    profit: -100,
    date: '2025-01-20T14:10:00Z',
    result: 'loss'
  },
  {
    id: 'game-h-003',
    gameName: 'Mahjong Ways 2',
    provider: 'PG SOFT',
    betAmount: 75,
    winAmount: 450,
    profit: 375,
    date: '2025-01-20T13:55:00Z',
    result: 'win'
  },
  {
    id: 'game-h-004',
    gameName: 'Fortune Tiger',
    provider: 'PG SOFT',
    betAmount: 60,
    winAmount: 30,
    profit: -30,
    date: '2025-01-20T13:40:00Z',
    result: 'loss'
  },
  {
    id: 'game-h-005',
    gameName: 'Book of Dead',
    provider: "Play'n GO",
    betAmount: 80,
    winAmount: 320,
    profit: 240,
    date: '2025-01-20T13:20:00Z',
    result: 'win'
  }
];

export const mockNotifications = [
  {
    id: 'notif-001',
    type: 'bonus',
    title: 'Welcome Bonus Credited',
    message: 'Your 100% welcome bonus of 5000 USDT has been credited to your account',
    date: '2025-01-20T10:20:00Z',
    read: false
  },
  {
    id: 'notif-002',
    type: 'withdrawal',
    title: 'Withdrawal Completed',
    message: 'Your withdrawal of 2500 USDT has been processed successfully',
    date: '2025-01-19T17:00:00Z',
    read: true
  },
  {
    id: 'notif-003',
    type: 'vip',
    title: 'VIP Level Upgraded',
    message: 'Congratulations! You have been upgraded to Gold VIP level',
    date: '2025-01-18T12:00:00Z',
    read: true
  }
];
